export const publish = (eventName, data) => {
  window.LIFE_CYCLE_EVENT_BUS.trigger(eventName, data);
};
